import React from 'react';
import { InstoreService, InstoreServicesList } from '../../containers/instore';
import { SEOText } from '../../common/components';
import { useInstorePage } from './hooks';

export const InstorePage = () => {
	const { categoryId } = useInstorePage();

	return (
		<div className="services-landings__content">
			{categoryId ? <InstoreService /> : <InstoreServicesList />}
			<SEOText />
		</div>
	);
};
